import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconController12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconController12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 2H4a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1m2.915 1A1.5 1.5 0 0 1 4 4H2.5a1.5 1.5 0 1 1 0-3H4a1.5 1.5 0 0 1 1.415 1H10.5a.5.5 0 0 1 0 1zM7.5 9.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 0-1H8a.5.5 0 0 0-.5.5M6.585 9H1.5v.5V9a.5.5 0 0 0 0 1v-.5.5h5.085A1.5 1.5 0 0 0 8 11h1.5a1.5 1.5 0 0 0 0-3H8a1.5 1.5 0 0 0-1.415 1M5.5 6.5a.5.5 0 0 1 0-1H7a.5.5 0 0 1 0 1zm-1.415 0H1.5a.5.5 0 0 1 0-1h2.585a1.5 1.5 0 0 1 1.415-1H7a1.5 1.5 0 0 1 1.415 1H10.5a.5.5 0 1 1 0 1H8.415A1.5 1.5 0 0 1 7 7.5H5.5a1.5 1.5 0 0 1-1.415-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconController12);
